/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getPharmacyStockBills } from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { getEntities as getPharmacyCredits } from 'app/entities/pharmacy-credit/pharmacy-credit.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { CreditType } from 'app/shared/model/enumerations/credit-type.model';
import { ClosureStatus } from 'app/shared/model/enumerations/closure-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-credit.reducer';

export const PharmacyCreditUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacyStockBills = useAppSelector(state => state.pharmacyStockBill.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyCredits = useAppSelector(state => state.pharmacyCredit.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyCreditEntity = useAppSelector(state => state.pharmacyCredit.entity);
  const loading = useAppSelector(state => state.pharmacyCredit.loading);
  const updating = useAppSelector(state => state.pharmacyCredit.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyCredit.updateSuccess);
  const creditTypeValues = Object.keys(CreditType);
  const closureStatusValues = Object.keys(ClosureStatus);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-credit${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getPharmacyStockBills({}));
    dispatch(getPharmacyReturnBills({}));
    dispatch(getPharmacyCredits({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAmount !== undefined && typeof values.totalAmount !== 'number') {
      values.totalAmount = Number(values.totalAmount);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.pendingAmount !== undefined && typeof values.pendingAmount !== 'number') {
      values.pendingAmount = Number(values.pendingAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacyCreditEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
      purchasePayment: pharmacyStockBills.find(it => it.id.toString() === values.purchasePayment?.toString()),
      returnPayment: pharmacyReturnBills.find(it => it.id.toString() === values.returnPayment?.toString()),
      amendedFrom: pharmacyCredits.find(it => it.id.toString() === values.amendedFrom?.toString()),
      amendedTo: pharmacyCredits.find(it => it.id.toString() === values.amendedTo?.toString()),
      invoiceType: clinicalDictionaries.find(it => it.id.toString() === values.invoiceType?.toString()),
      urType: clinicalDictionaries.find(it => it.id.toString() === values.urType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          creditType: 'IN',
          closureStatus: 'PENDING',
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyCreditEntity,
          pharmacy: pharmacyCreditEntity?.pharmacy?.id,
          supplier: pharmacyCreditEntity?.supplier?.id,
          purchasePayment: pharmacyCreditEntity?.purchasePayment?.id,
          returnPayment: pharmacyCreditEntity?.returnPayment?.id,
          amendedFrom: pharmacyCreditEntity?.amendedFrom?.id,
          amendedTo: pharmacyCreditEntity?.amendedTo?.id,
          invoiceType: pharmacyCreditEntity?.invoiceType?.id,
          urType: pharmacyCreditEntity?.urType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyCredit.home.createOrEditLabel" data-cy="PharmacyCreditCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.home.createOrEditLabel">Create or edit a PharmacyCredit</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-credit-id"
                  label={translate('tinyMedicRestApp.pharmacyCredit.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.totalAmount')}
                id="pharmacy-credit-totalAmount"
                name="totalAmount"
                data-cy="totalAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.paidAmount')}
                id="pharmacy-credit-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.pendingAmount')}
                id="pharmacy-credit-pendingAmount"
                name="pendingAmount"
                data-cy="pendingAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.creditType')}
                id="pharmacy-credit-creditType"
                name="creditType"
                data-cy="creditType"
                type="select"
              >
                {creditTypeValues.map(creditType => (
                  <option value={creditType} key={creditType}>
                    {translate(`tinyMedicRestApp.CreditType.${creditType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.addedById')}
                id="pharmacy-credit-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.modifiedById')}
                id="pharmacy-credit-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.closureStatus')}
                id="pharmacy-credit-closureStatus"
                name="closureStatus"
                data-cy="closureStatus"
                type="select"
              >
                {closureStatusValues.map(closureStatus => (
                  <option value={closureStatus} key={closureStatus}>
                    {translate(`tinyMedicRestApp.ClosureStatus.${closureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.active')}
                id="pharmacy-credit-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.cursor')}
                id="pharmacy-credit-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.timestampentry')}
                id="pharmacy-credit-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.microSec')}
                id="pharmacy-credit-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.lastUpdated')}
                id="pharmacy-credit-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.addedByType')}
                id="pharmacy-credit-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.modifiedByType')}
                id="pharmacy-credit-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.cancelledReason')}
                id="pharmacy-credit-cancelledReason"
                name="cancelledReason"
                data-cy="cancelledReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.billNumber')}
                id="pharmacy-credit-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <UncontrolledTooltip target="billNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.billNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.amended')}
                id="pharmacy-credit-amended"
                name="amended"
                data-cy="amended"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="amendedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.amended" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyCredit.preGst')}
                id="pharmacy-credit-preGst"
                name="preGst"
                data-cy="preGst"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="preGstLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.preGst" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-credit-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyCredit.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyCredit.supplier')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-purchasePayment"
                name="purchasePayment"
                data-cy="purchasePayment"
                label={translate('tinyMedicRestApp.pharmacyCredit.purchasePayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-returnPayment"
                name="returnPayment"
                data-cy="returnPayment"
                label={translate('tinyMedicRestApp.pharmacyCredit.returnPayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-amendedFrom"
                name="amendedFrom"
                data-cy="amendedFrom"
                label={translate('tinyMedicRestApp.pharmacyCredit.amendedFrom')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyCredits
                  ? pharmacyCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-amendedTo"
                name="amendedTo"
                data-cy="amendedTo"
                label={translate('tinyMedicRestApp.pharmacyCredit.amendedTo')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyCredits
                  ? pharmacyCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-invoiceType"
                name="invoiceType"
                data-cy="invoiceType"
                label={translate('tinyMedicRestApp.pharmacyCredit.invoiceType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-credit-urType"
                name="urType"
                data-cy="urType"
                label={translate('tinyMedicRestApp.pharmacyCredit.urType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-credit" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyCreditUpdate;
